(function() {
  'use strict';

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function init(table) {
    if (table.dataset.bulkDiscountsReady === 'true') return;
    table.dataset.bulkDiscountsReady = 'true';

    var productJson = table.querySelector('[data-bulk-discounts-product]');
    var product;

    try {
      product = productJson ? JSON.parse(productJson.textContent) : null;
    } catch (error) {
      product = null;
    }

    if (!product || !Array.isArray(product.variants)) {
      table.hidden = true;
      return;
    }

    var productForm = table.closest('[data-product-form]');
    var variantSelection = productForm && productForm.querySelector('[data-variant-selection]');
    var variantInput = productForm && productForm.querySelector('[data-variants]');
    var moneyFormat = table.dataset.moneyFormat || '${{amount}}';
    var bulkDiscountUnit = table.dataset.bulkDiscountUnit || 'Case';
    var bulkDiscountSecondaryUnit = table.dataset.bulkDiscountSecondaryUnit || 'Roll';
    var bulkDiscountVariantUnit = normalize(table.dataset.bulkDiscountVariantUnit || 'Case');
    var caseOptionIndex = -1;

    product.variants.some(function(variant) {
      return variant.options.some(function(option, index) {
        if (normalize(option) === bulkDiscountVariantUnit) {
          caseOptionIndex = index;
          return true;
        }

        return false;
      });
    });

    function formatMoney(cents) {
      var amount = Number(cents) / 100;
      var format = moneyFormat || '${{amount}}';
      var token = /\{\{\s*(amount(?:_no_decimals)?(?:_with_comma_separator|_with_apostrophe_separator)?)\s*\}\}/;
      var match = format.match(token);

      if (!match || !Number.isFinite(amount)) return '\u2014';

      var formatType = match[1];
      var precision = formatType.indexOf('no_decimals') > -1 ? 0 : 2;
      var thousandsSeparator = ',';
      var decimalSeparator = '.';

      if (formatType.indexOf('with_comma_separator') > -1) {
        thousandsSeparator = '.';
        decimalSeparator = ',';
      } else if (formatType.indexOf('with_apostrophe_separator') > -1) {
        thousandsSeparator = "'";
      }

      var formattedAmount = amount.toFixed(precision);
      var parts = formattedAmount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

      return format.replace(token, parts.join(precision ? decimalSeparator : ''));
    }

    function findVariant(id) {
      return product.variants.find(function(variant) {
        return String(variant.id) === String(id);
      }) || null;
    }

    function getMatchingCaseVariant(selectedVariant) {
      if (!selectedVariant || caseOptionIndex < 0) return null;

      return product.variants.find(function(variant) {
        if (normalize(variant.options[caseOptionIndex]) !== bulkDiscountVariantUnit) return false;

        return variant.options.every(function(option, index) {
          return index === caseOptionIndex || option === selectedVariant.options[index];
        });
      }) || null;
    }

    function updatePrices(selectedVariant) {
      var caseVariant = getMatchingCaseVariant(selectedVariant);

      if (!caseVariant) {
        table.hidden = true;
        return;
      }

      var rollsPerCase = Number(caseVariant.rollsPerCase);
      table.hidden = false;

      table.querySelectorAll('[data-bulk-discount-row]').forEach(function(row) {
        var percent = Number(row.dataset.bulkDiscountPercent);
        var casePriceEl = row.querySelector('[data-bulk-discount-case-price]');
        var rollPriceEl = row.querySelector('[data-bulk-discount-roll-price]');

        if (!Number.isFinite(percent) || !casePriceEl || !rollPriceEl) return;

        var discountedCasePrice = Math.round(Number(caseVariant.price) * (100 - percent) / 100);
        casePriceEl.textContent = formatMoney(discountedCasePrice) + ' / ' + bulkDiscountUnit;
        rollPriceEl.textContent = rollsPerCase > 0
          ? formatMoney(Math.round(discountedCasePrice / rollsPerCase)) + ' / ' + bulkDiscountSecondaryUnit
          : '\u2014';
      });
    }

    if (variantSelection) {
      variantSelection.addEventListener('variant-change', function(event) {
        var changedVariant = event.detail && event.detail.variant;
        updatePrices(findVariant(changedVariant && changedVariant.id));
      });
    }

    if (productForm) {
      productForm.addEventListener('change', function() {
        window.setTimeout(function() {
          updatePrices(findVariant(variantInput && variantInput.value));
        }, 0);
      });
    }

    updatePrices(findVariant(variantInput && variantInput.value));
  }

  document.querySelectorAll('[data-bulk-discounts]').forEach(init);
})();
